var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M20.5 18a4.857 4.857 0 012.791 8.833c3.323.815 5.709 3.05 5.709 5.677 0 1.122-1.94 1.864-4.51 2.228l-.628.08c-2.13.243-4.595.243-6.724 0l-.628-.08C13.94 34.374 12 33.632 12 32.51c0-2.628 2.386-4.862 5.71-5.679A4.857 4.857 0 0120.5 18zm7-5a4.857 4.857 0 012.791 8.833c3.323.815 5.709 3.05 5.709 5.677 0 1.122-1.94 1.864-4.51 2.228l-.628.08c-.418.048-.85.086-1.29.115-.744-1.466-2.11-2.696-3.867-3.52l-.229-.104.077-.11a6.06 6.06 0 00-2.866-8.993A4.857 4.857 0 0127.5 13z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
